// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-payload-con[data-v-052cd9a0] {
  width: 100%;
  border: 1px solid #eee;
  border-radius: 5px;
  padding: 10px;
  display: block;
  font-size: 13px !important;
  text-align: center;
  text-decoration: underline !important;
  color: #0000ee !important;
}
.mb-c-10[data-v-052cd9a0] {
  margin-bottom: 10px;
}
.mb-c-10[data-v-052cd9a0]:last-child {
  margin-bottom: 0 !important;
}
@media (min-width: 1900px) {
.custom-payload-con[data-v-052cd9a0] {
    font-size: 15px !important;
    padding: 15px;
}
}
@media (min-width: 2500px) {
.custom-payload-con[data-v-052cd9a0] {
    font-size: 15px;
    padding: 15px;
}
}
.vdv_video_icon img[data-v-052cd9a0] {
  filter: invert(1);
  height: 20px;
  width: 20px;
}
.vdv_link span[data-v-052cd9a0] {
  top: 0px;
}
`, "",{"version":3,"sources":["webpack://./src/components/ChatWidget/TvmFlowEndItems/TvmFlowEndLink.vue","webpack://./TvmFlowEndLink.vue"],"names":[],"mappings":"AACA;EACE,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,0BAAA;EACA,kBAAA;EACA,qCAAA;EACA,yBAAA;ACAF;ADGA;EACE,mBAAA;ACDF;ADGE;EACE,2BAAA;ACDJ;ADKA;AACE;IACE,0BAAA;IACA,aAAA;ACHF;AACF;ADMA;AACE;IACE,eAAA;IACA,aAAA;ACJF;AACF;ADOA;EACE,iBAAA;EACA,YAAA;EACA,WAAA;ACLF;ADQA;EACE,QAAA;ACNF","sourcesContent":["\n.custom-payload-con {\n  width: 100%;\n  border: 1px solid #eee;\n  border-radius: 5px;\n  padding: 10px;\n  display: block;\n  font-size: 13px !important;\n  text-align: center;\n  text-decoration: underline !important;\n  color: #0000ee !important;\n}\n\n.mb-c-10 {\n  margin-bottom: 10px;\n\n  &:last-child {\n    margin-bottom: 0 !important;\n  }\n}\n\n@media (min-width: 1900px) {\n  .custom-payload-con {\n    font-size: 15px !important;\n    padding: 15px;\n  }\n}\n\n@media (min-width: 2500px) {\n  .custom-payload-con {\n    font-size: 15px;\n    padding: 15px;\n  }\n}\n\n.vdv_video_icon img {\n  filter: invert(1);\n  height: 20px;\n  width: 20px;\n}\n\n.vdv_link span {\n  top: 0px;\n}\n",".custom-payload-con {\n  width: 100%;\n  border: 1px solid #eee;\n  border-radius: 5px;\n  padding: 10px;\n  display: block;\n  font-size: 13px !important;\n  text-align: center;\n  text-decoration: underline !important;\n  color: #0000ee !important;\n}\n.mb-c-10 {\n  margin-bottom: 10px;\n}\n.mb-c-10:last-child {\n  margin-bottom: 0 !important;\n}\n@media (min-width: 1900px) {\n  .custom-payload-con {\n    font-size: 15px !important;\n    padding: 15px;\n  }\n}\n@media (min-width: 2500px) {\n  .custom-payload-con {\n    font-size: 15px;\n    padding: 15px;\n  }\n}\n.vdv_video_icon img {\n  filter: invert(1);\n  height: 20px;\n  width: 20px;\n}\n.vdv_link span {\n  top: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
